<template>
  <a
    :href="href"
    class="store-dl"
    :class="[`store-dl--${variant}`, `store-dl--${size}`]"
    target="_blank"
    rel="noopener noreferrer"
  >
    <span class="store-dl__icon-wrap" aria-hidden="true">
      <!-- Flat Android / Play-style tile (original artwork; not a trademarked badge) -->
      <svg
        v-if="variant === 'play'"
        class="store-dl__svg store-dl__svg--play"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="5" fill="#008d36" />
        <path fill="#fff" d="M8.5 7.25v9.5L17 12l-8.5-4.75z" />
      </svg>
      <!-- Stroke apple (Lucide-style silhouette; decorative) -->
      <svg
        v-else
        class="store-dl__svg store-dl__svg--apple"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="5" fill="#141416" />
        <g fill="none" stroke="#f5f5f7" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
          <path
            d="M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-3 6-6.5 0-4.5-3-8.5-6-8.5-1 0-2 .5-3 1.5-1-1-2-1.5-3-1.5-3 0-6 4-6 8.5 0 3.5 3 6.5 6 6.5 1.25 0 2.5-1.06 4-1.06z"
          />
          <path d="M15.86 2.5c.82 1.14 1.14 2.5 1 3.86-1.14-.21-2.5-.64-3.5-1.5-1-.86-1.86-2-2-3.5 1.36-.14 2.72.18 3.5 1.14z" />
        </g>
      </svg>
    </span>
    <span class="store-dl__copy">
      <span class="store-dl__kicker">{{ kicker }}</span>
      <span class="store-dl__name">{{ title }}</span>
    </span>
  </a>
</template>

<script>
export default {
  name: 'StoreDownloadLink',
  props: {
    variant: {
      type: String,
      required: true,
      validator: (v) => v === 'play' || v === 'apple',
    },
    size: {
      type: String,
      default: 'prominent',
      validator: (v) => v === 'compact' || v === 'prominent',
    },
    href: {
      type: String,
      required: true,
    },
  },
  computed: {
    kicker() {
      return this.variant === 'play' ? 'Get it on' : 'Download on';
    },
    title() {
      return this.variant === 'play' ? 'Google Play' : 'App Store';
    },
  },
};
</script>

<style scoped>
.store-dl {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
  color: #f1f5f9;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  flex-shrink: 0;
}

.store-dl:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
  box-shadow: 0 10px 28px -12px rgba(0, 0, 0, 0.55);
}

.store-dl--compact {
  padding: 0.4rem 0.85rem 0.4rem 0.5rem;
  min-height: 42px;
}

.store-dl--prominent {
  padding: 0.55rem 1rem 0.55rem 0.6rem;
  min-height: 52px;
  min-width: min(100%, 168px);
  flex: 1 1 160px;
}

.store-dl__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 10px;
  overflow: hidden;
}

.store-dl--compact .store-dl__icon-wrap {
  width: 34px;
  height: 34px;
}

.store-dl--prominent .store-dl__icon-wrap {
  width: 40px;
  height: 40px;
}

.store-dl__svg {
  display: block;
  width: 100%;
  height: 100%;
}

.store-dl__copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;
  text-align: left;
}

.store-dl__kicker {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}

.store-dl--prominent .store-dl__kicker {
  font-size: 0.6875rem;
}

.store-dl__name {
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.store-dl--prominent .store-dl__name {
  font-size: 1rem;
}
</style>
